module.exports = __webpack_public_path__ + "static/media/must_post.974eaafe.svg";